var EditorError = class extends Error {
	constructor(message) {
		super(message);
		this.name = "EditorError";
	}
};
var InvalidStateError = class extends EditorError {
	constructor(message) {
		super(message);
		this.name = "InvalidStateError";
	}
};
var NoSourcePathError = class extends EditorError {
	constructor(message) {
		super(message);
		this.name = "NoSourcePathError";
	}
};
var FileSystemNotAvailableError = class extends EditorError {
	constructor(message) {
		super(message);
		this.name = "FileSystemNotAvailableError";
	}
};
var DocumentLoadError = class extends EditorError {
	constructor(message, cause) {
		super(message);
		this.name = "DocumentLoadError";
		this.cause = cause;
	}
};
const DocxEncryptionErrorCode = {
	PASSWORD_REQUIRED: "DOCX_PASSWORD_REQUIRED",
	PASSWORD_INVALID: "DOCX_PASSWORD_INVALID",
	ENCRYPTION_UNSUPPORTED: "DOCX_ENCRYPTION_UNSUPPORTED",
	DECRYPTION_FAILED: "DOCX_DECRYPTION_FAILED"
};
var DocxEncryptionError = class extends EditorError {
	constructor(code, message, cause) {
		super(message);
		this.name = "DocxEncryptionError";
		this.code = code;
		this.cause = cause;
	}
};
export { InvalidStateError as a, FileSystemNotAvailableError as i, DocxEncryptionErrorCode as n, NoSourcePathError as o, DocumentLoadError as r, DocxEncryptionError as t };
